module.exports = __webpack_public_path__ + "img/2100f.f55a4bf9.png";